import { render } from "./ProductImageDialog.vue?vue&type=template&id=25265a0e"
import script from "./ProductImageDialog.vue?vue&type=script&lang=js"
export * from "./ProductImageDialog.vue?vue&type=script&lang=js"

import "./ProductImageDialog.vue?vue&type=style&index=0&id=25265a0e&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__